'use client';

import { useTracking } from '@packages/tracking/src/hooks/useTracking/useTracking';
import type {
  GTMEventGlycerinImageClick,
  GTMEventGlycerinButtonClick,
  GTMEventGlycerinCheckboxClick,
  GTMEventGlycerinDisplayOverlay,
} from '@packages/tracking/src/types/events';

export const useInstallmentCalculatorTracking = () => {
  const dispatchTracking = useTracking();

  const trackGlycerinImageClick = () => {
    dispatchTracking<GTMEventGlycerinImageClick>({
      event: 'ImageClick',
      ImageClickData: {
        category: 'Ratenrechner',
        detail: 'Infosymbol',
        label: 'Kredit-Promo',
      },
    });
  };

  const trackInstallmentValueTileClick = (detail: string | number) => {
    dispatchTracking<GTMEventGlycerinButtonClick>({
      event: 'ButtonClick',
      ButtonClickData: {
        category: 'Ratenrechner',
        detail: `Monatsrate ${detail}`,
        label: 'Kredit-Promo',
      },
    });
  };

  const trackSliderClick = (detail: string | number) => {
    dispatchTracking<GTMEventGlycerinButtonClick>({
      event: 'ButtonClick',
      ButtonClickData: {
        category: 'Ratenrechner',
        detail: `Monatsrate ${detail}`,
        label: 'Kredit-Promo',
      },
    });
  };

  const trackPaymentPauseClick = (checked: boolean) => {
    dispatchTracking<GTMEventGlycerinCheckboxClick>({
      event: 'CheckboxClick',
      CheckboxClickData: {
        category: 'Ratenrechner',
        detail: 'Valuta',
        label: 'Kredit-Promo',
        isChecked: checked,
      },
    });
  };

  const trackDialogOpen = () => {
    dispatchTracking<GTMEventGlycerinDisplayOverlay>({
      event: 'DisplayOverlay',
      DisplayOverlayData: {
        category: 'Ratenrechner',
        label: 'Kredit-Promo',
      },
    });
  };

  return {
    trackGlycerinImageClick,
    trackInstallmentValueTileClick,
    trackPaymentPauseClick,
    trackSliderClick,
    trackDialogOpen,
  };
};
